<template>
    <v-app class="vuetify-layout">
        <v-navigation-drawer v-model="openSidebar"
        width="260"
        app
        clipped
        :mini-variant.sync="mini"
        :mini-variant-width="$vuetify.breakpoint.xs ? 94 : 86"
        mobile-breakpoint="600"
        hide-overlay
        :touchless="!$vuetify.breakpoint.xs"
        :permanent="!$vuetify.breakpoint.xs"
        >
            <v-list nav>
                <inertia-link href="/backoffice" @click="openSidebar = false">
                    <v-list-item
                    link :class="{'v-list-item--active' : $page.props.currentRouteName == 'backoffice.home.index' }"
                    id="dashboard">
                        <v-list-item-icon>
                            <v-icon>mdi-view-dashboard-outline</v-icon>
                            <p class="mobile-label">{{$page.props.lang.menu_dashboard || "Dashboard"}}</p>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{$page.props.lang.menu_dashboard || "Dashboard"}}</v-list-item-title>
                        </v-list-item-content>
                        <v-tooltip activator="#dashboard" right open-delay="500">
                            <span>{{$page.props.lang.menu_dashboard || "Dashboard"}}</span>
                        </v-tooltip>
                    </v-list-item>
                </inertia-link>
                <inertia-link href="/backoffice/members" v-if="$page.props.p['members.read']" @click="openSidebar = false">
                    <v-list-item
                    link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('backoffice.members') }"
                    id="members">
                        <v-list-item-icon>
                            <v-icon>mdi-account-group-outline</v-icon>
                            <p class="mobile-label">{{$page.props.lang.menu_members || "Members"}}</p>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ $page.props.lang.menu_members || "Members"}}</v-list-item-title>
                        </v-list-item-content>
                        <v-tooltip activator="#members" right open-delay="500">
                            <span>{{$page.props.lang.menu_members || "Members"}}</span>
                        </v-tooltip>
                    </v-list-item>
                </inertia-link>
                <inertia-link href="/backoffice/trainers" v-if="$page.props.p['trainers']" @click="openSidebar = false">
                    <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('backoffice.trainers') }" id="trainers">
                        <v-list-item-icon>
                            <v-icon>mdi-account-star-outline</v-icon>
                            <p class="mobile-label">{{$page.props.lang.menu_trainers || "Trainers"}}</p>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{$page.props.lang.menu_trainers || "Trainers"}}</v-list-item-title>
                        </v-list-item-content>
                        <v-tooltip activator="#trainers" right open-delay="500">
                            <span>{{$page.props.lang.menu_trainers || "Trainers"}}</span>
                        </v-tooltip>
                    </v-list-item>
                </inertia-link>
                <inertia-link href="/backoffice/subscriptions" v-if="$page.props.p['settings']" @click="openSidebar = false">
                    <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('backoffice.subscriptions')}" id="subscriptions">
                        <v-list-item-icon>
                            <v-icon>mdi-account-details-outline</v-icon>
                            <p class="mobile-label">{{$page.props.lang.menu_subscriptions || "Membership"}}</p>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{$page.props.lang.menu_subscriptions || "Memberships"}}</v-list-item-title>
                        </v-list-item-content>
                        <v-tooltip activator="#subscriptions" right open-delay="500">
                            <span>{{$page.props.lang.menu_subscriptions || "Memberships"}}</span>
                        </v-tooltip>
                    </v-list-item>
                </inertia-link>
                <inertia-link href="/backoffice/calendar" @click="openSidebar = false">
                    <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName == 'backoffice.calendar.index'}" id="calendar">
                        <v-list-item-icon>
                            <v-icon>mdi-calendar-month-outline</v-icon>
                            <p class="mobile-label">{{ $page.props.lang.menu_calendar || "Calendar"}}</p>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ $page.props.lang.menu_calendar || "Calendar"}}</v-list-item-title>
                        </v-list-item-content>
                        <v-tooltip activator="#calendar" right open-delay="500">
                            <span>{{ $page.props.lang.menu_calendar || "Calendar"}}</span>
                        </v-tooltip>
                    </v-list-item>
                </inertia-link>
                <inertia-link href="/backoffice/messages" @click="openSidebar = false">
                    <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName == 'backoffice.messages.index'}" id="messages">
                        <v-list-item-icon>
                            <v-icon>mdi-email-send-outline</v-icon>
                            <p class="mobile-label">{{ $page.props.lang.menu_messages || "Messages"}}</p>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ $page.props.lang.menu_messages || "Messages"}}</v-list-item-title>
                        </v-list-item-content>
                        <v-tooltip activator="#messages" right open-delay="500">
                            <span>{{ $page.props.lang.menu_messages || "Messages"}}</span>
                        </v-tooltip>
                    </v-list-item>
                </inertia-link>
                <v-list-group v-if="$page.props.p['pos'] && $page.props.organization.features['pos']" :value="openedPos" @change="openedPos = !openedPos" active-class="openedNav">
                    <template v-slot:activator>
                        <v-list-item-icon>
                            <v-icon>mdi-basket-outline</v-icon>
                            <p class="mobile-label">
                                <v-icon v-if="!openedPos" small>mdi-chevron-down</v-icon>
                                <v-icon  v-if="openedPos" small>mdi-chevron-up</v-icon>
                                </p>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ $page.props.lang.menu_shop || "Shop"}}</v-list-item-title>
                        </v-list-item-content>
                        <v-tooltip activator="#pos" right open-delay="500">
                            <span>{{ $page.props.lang.menu_shop || "Shop"}}</span>
                        </v-tooltip>
                    </template>
                    <inertia-link href="/backoffice/pos" v-if="$page.props.p['pos']" @click="openSidebar = false">
                        <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('backoffice.pos.index')}" id="pos">
                            <v-list-item-icon>
                                <v-icon>mdi-cart</v-icon>
                                <p class="mobile-label">{{ $page.props.lang.menu_shop || "Shop"}}</p>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ $page.props.lang.menu_shop || "Shop"}}</v-list-item-title>
                            </v-list-item-content>
                            <v-tooltip activator="#pos" right open-delay="500">
                                <span>{{ $page.props.lang.menu_shop || "Shop"}}</span>
                            </v-tooltip>
                        </v-list-item>
                    </inertia-link>
                    <inertia-link href="/backoffice/products" v-if="$page.props.p['finance']" @click="openSidebar = false">
                        <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('backoffice.products.index')}" id="products">
                            <v-list-item-icon>
                                <v-icon>mdi-tag</v-icon>
                                <p class="mobile-label">{{ $page.props.lang.menu_products || "Products"}}</p>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ $page.props.lang.menu_products || "Products"}}</v-list-item-title>
                            </v-list-item-content>
                            <v-tooltip activator="#products" right open-delay="500">
                                <span>{{ $page.props.lang.menu_products || "Products"}}</span>
                            </v-tooltip>
                        </v-list-item>
                    </inertia-link>
                    <inertia-link href="/backoffice/invoices" v-if="$page.props.p['finance']" @click="openSidebar = false">
                        <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('backoffice.invoices.index')}" id="invoices">
                            <v-list-item-icon>
                                <v-icon>mdi-receipt</v-icon>
                                <p class="mobile-label">{{ $page.props.lang.menu_invoices || "Invoices"}}</p>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ $page.props.lang.menu_invoices || "Invoices"}}</v-list-item-title>
                            </v-list-item-content>
                            <v-tooltip activator="#products" right open-delay="500">
                                <span>{{ $page.props.lang.menu_invoices || "Invoices"}}</span>
                            </v-tooltip>
                        </v-list-item>
                    </inertia-link>
                </v-list-group>
                <inertia-link href="/backoffice/expenses" v-if="$page.props.p['finance'] && $page.props.organization.features['expenses']" @click="openSidebar = false">
                    <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('backoffice.expenses.index')}" id="expenses">
                        <v-list-item-icon>
                            <v-icon>mdi-currency-usd</v-icon>
                            <p class="mobile-label">{{ $page.props.lang.menu_expenses || "Expenses"}}</p>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ $page.props.lang.menu_expenses || "Expenses"}}</v-list-item-title>
                        </v-list-item-content>
                        <v-tooltip activator="#expenses" right open-delay="500">
                            <span>{{ $page.props.lang.menu_expenses || "Expenses"}}</span>
                        </v-tooltip>
                    </v-list-item>
                </inertia-link>
                <inertia-link href="/backoffice/reports" v-show="$page.props.p['reports']" @click="openSidebar = false">
                    <v-list-item link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('backoffice.reports')}" id="reports">
                        <v-list-item-icon>
                            <v-icon>mdi-chart-line</v-icon>
                            <p class="mobile-label">{{ $page.props.lang.menu_reports || "Reports"}}</p>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ $page.props.lang.menu_reports || "Reports"}}</v-list-item-title>
                        </v-list-item-content>
                        <v-tooltip activator="#reports" right open-delay="500">
                            <span>{{ $page.props.lang.menu_reports || "Reports"}}</span>
                        </v-tooltip>
                    </v-list-item>
                </inertia-link>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar app class="navbar" clipped-left elevation="1" dark :style="{ backgroundColor : $page.props.organization.themeOptions.primary}">
            <div class="left d-flex align-center">
                <v-btn v-if="$vuetify.breakpoint.xs" elevation="1" fab small @click="openSidebar = !openSidebar">
                    <v-icon>mdi-menu</v-icon>
                </v-btn>
                <logo class="ml-1" :logo="$page.props.organization.settings.main_logo_path"></logo>
                <v-autocomplete
                v-if="!$vuetify.breakpoint.xs"
                v-model="searchField"
                :search-input.sync="searchMembers"
                :items="resultMembers"
                @change="memberSelected"
                :placeholder="$page.props.lang.filter_search || 'Search'"
                item-text="full_name"
                return-object
                :loading="isLoading" append-icon=""
                prepend-inner-icon="mdi-magnify"
                hide-no-data
                hide-selected
                multiple hide-details
                dense solo flat class="search-members">
                    <template v-slot:selection="data">
                        <p @change="memberSelected(data.item)"></p>
                    </template>
                    <template v-slot:item="data">
                        <v-list-item-avatar size="32">
                            <img :src="data.item.profile_photo">
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title v-html="data.item.full_name"></v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-btn v-if="data.item.is_checkedin == false" @click.stop.prevent="checkIn(data.item)" small outlined color="primary">{{ $page.props.lang.check_in || "Check-in" }}</v-btn>
                            <v-btn v-else @click.stop.prevent="checkIn(data.item)" small outlined color="primary">{{ $page.props.lang.check_out || "Check-out" }}</v-btn>
                        </v-list-item-action>
                    </template>
                </v-autocomplete>
            </div>
            <v-spacer />
            <div class="right">
                <v-menu offset-y origin="top right" transition="scale-transition">
                    <template v-slot:activator="{ on, attrs }">
                        <div class="dropdown-button" elevation="1" v-bind="attrs" v-on="on">
                            <div class="info-wrap" v-show="!$vuetify.breakpoint.xs">
                                <p class="user-full-name">{{ $page.props.user.name }}</p>
                                <p class="user-organization">{{ $page.props.organization.name }}</p>
                            </div>
                            <v-avatar class="ml-1">
                                <img :src="$page.props.user.profile_photo_url" :alt="$page.props.user.name" class="h-8 w-8 rounded-full object-cover"/>
                            </v-avatar>
                            <v-icon class="arrow">mdi-menu-down</v-icon>
                        </div>
                    </template>
                    <v-list expand nav>
                        <inertia-link href="/user/profile">
                            <v-list-item link>
                                <v-list-item-content>
                                    <v-list-item-title>{{ $page.props.lang.profil || "Profile" }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </inertia-link>
                        <inertia-link href="/backoffice/settings" v-show="$page.props.p['settings']">
                            <v-list-item link>
                                <v-list-item-content>
                                    <v-list-item-title>{{ $page.props.lang.settings || "Settings" }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </inertia-link>
                        <a target="_blank" href="https://docs.google.com/document/d/1-cPhVYACwtS3ns2PeoZ-9cXEbkLNvq3ouiiKJDJTWdg/edit?usp=sharing">
                            <v-list-item link>
                                <v-list-item-content>
                                    <v-list-item-title>{{ $page.props.lang.help || "Help" }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </a>
                        <a  @click="logout">
                            <v-list-item link>
                                <v-list-item-content>
                                    <v-list-item-title>{{ $page.props.lang.signout || "Sign Out"}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </a>
                    </v-list>
                </v-menu>
            </div>
        </v-app-bar>

        <v-snackbars :objects.sync="messageObjects" top right>
            <template v-slot:action="{ close }">
                <v-btn text @click="close()" icon><v-icon>mdi-close</v-icon></v-btn>
            </template>
        </v-snackbars>

        <v-main app fluid absolute>
            <div class="mt-3 ml-5 mr-5" v-for="alert in messages" :key="alert.id">
                <v-alert v-if="messages.length > 0" class="ml-3 mr-3 pt-5" :type="getType(alert.type)" text dense>
                    <span v-html="alert.content"></span>
                </v-alert>
            </div>
            <div class="slot" fluid>
                <slot name="header" class="page-header"></slot>
                <slot></slot>
            </div>
        </v-main>

        <CheckinModal :modal="checkInModal" :memberSubs="memberSubs"
        @close="checkInModal = false"
        @checkin="checkIn">
        </CheckinModal>

        <v-dialog v-model="checkInSuccess" max-width="500px">
            <v-card class="mx-auto">
                <v-card-title class="subtitle-1"><v-icon color="green">mdi-account-check-outline</v-icon> {{checkInModel.message}}</v-card-title>
                <v-list-item three-line>
                    <v-list-item-avatar
                    tile
                    size="80"
                    color="grey"
                ><img :src="checkInModel.member.profile_photo_url + '?w=220'" alt="" ></v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title class="headline mb-1">
                    {{checkInModel.member.full_name || ""}}
                    </v-list-item-title>
                    <v-list-item-subtitle><v-icon>mdi-account-multiple-check-outline</v-icon> <b>{{checkInModel.membership.name || ""}}</b></v-list-item-subtitle>
                    <v-list-item-subtitle><v-icon>mdi-alarm</v-icon> <b>{{checkInModel.membership.end_date || ""}}</b></v-list-item-subtitle>
                    <v-list-item-subtitle><v-icon>mdi-calendar-range-outline</v-icon>  <b>{{checkInModel.membership.remaining_sessions}}</b></v-list-item-subtitle>
                </v-list-item-content>
                </v-list-item>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="checkInSuccess=false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="checkOutSuccess" max-width="500px">
            <v-card class="mx-auto">
                <v-card-title class="subtitle-1"><v-icon color="green">mdi-account-check-outline</v-icon> {{checkOutModel.message}}</v-card-title>
                <v-list-item three-line>
                    <v-list-item-avatar
                    tile
                    size="80"
                    color="grey"
                ><img :src="checkOutModel.member.profile_photo_url + '?w=220'" alt="" ></v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title class="headline mb-1">
                    {{checkOutModel.member.full_name || ""}}
                    </v-list-item-title>
                <v-list-item-subtitle><v-icon>mdi-account-multiple-check-outline</v-icon> <b>{{checkOutModel.membership.name || ""}}</b></v-list-item-subtitle>
                <v-list-item-subtitle><v-icon>mdi-alarm</v-icon> <b>{{checkOutModel.membership.end_date || ""}}</b></v-list-item-subtitle>
                <v-list-item-subtitle><v-icon>mdi-calendar-range-outline</v-icon>  <b>{{checkOutModel.membership.remaining_sessions}}</b></v-list-item-subtitle>
                </v-list-item-content>
                </v-list-item>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="checkOutSuccess=false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="checkInProgress" max-width="500px">
            <v-card>
                <v-card-title class="subtitle-1"> {{$page.props.lang.please_wait || "Please wait..."}}</v-card-title>
                <v-card-text class="text-center">
                     <v-progress-circular
                :size="50"
      color="primary"
      indeterminate
    ></v-progress-circular>
                </v-card-text>

            </v-card>
        </v-dialog>
    </v-app>
</template>


<script>
import Logo from '@/js/Components/Logo'
import CheckinModal from '@/js/Components/CheckinModal'
import EventBus from '@/js/eventbus'

export default {
    name: "AppLayout",
    components: {
        Logo,
        CheckinModal
    },
    data () {
        return {
            messages: this.$page.props.organization.messages,
            toggleMini: true,
            checkInModal: false,
            checkInSuccess: false,
            checkOutSuccess: false,
            checkInProgress: false,
            checkInModel: {
                member: {},
                membership: {}
            },
            checkOutModel:{
                member: {},
                membership: {}
            },
            checkin: {
                card_id: null,
                membership_id: null,
                member_id: null
            },

            memberSubs:[],
            messageObjects: [],
            openSidebar: false,
            searchMembers: null,
            resultMembers: [],
            searchField: [],
            isLoading: false,
            openedPos: false
        }
    },
    computed: {
        mini: {
            get() {
                return this.toggleMini
            },
            set() {
                return this.toggleMini
            }
        },
        mobile() {
            return this.$vuetify.breakpoint.width < 600
        }
    },
    created() {
        if(this.$page.props.locale == 'en'){
            this.$vuetify.lang.current = 'en';
        }else if(this.$page.props.locale == 'hr'){
            this.$vuetify.lang.current = 'hr';
        }

        EventBus.$on('SHOW_NOTIFICATION', (p) => {
            this.messageObjects.push(p)
        });

        EventBus.$on('SUCCESS_CHECKIN', (p) => {
            this.checkInSuccess = true;
            this.checkInModel = p;
        });

        EventBus.$on('SUCCESS_CHECKOUT', (p) => {
            this.checkOutSuccess = true;
            this.checkOutModel = p;
        });
    },

    watch: {
        'this.$vuetify.breakpoint.width': (value) => {
            if(value < 600) {
                this.mobile = true
            }
        },
        searchMembers(val) {
            if (val === '') {
                this.resultMembers = []
                return
            }

            if (this.isLoading) return

            this.isLoading = true

            axios.get('/backoffice/lookup/members', { params: { search: val }})
                .then(response => {
                    this.resultMembers = response.data.results
                    this.isLoading = false
                })
        },
    },
    methods: {
        getType(type){

            switch (type){
                case 0: return 'success';

                case 1: return 'info';

                case 2: return 'warning';

                case 3: return 'error';

            }
        },
        memberSelected(value) {

            this.searchMembers = null
            this.searchField = []
            this.$inertia.visit('/backoffice/members/details/' + value[0].id + '/overview', {method: 'get'})
        },
        logout() {
            axios.post('/logout').then(() => {
                window.location = '/'
            })
        },
        checkIn(params) {

            if(this.checkInProgress){
                return;
            }

            this.checkInProgress = true;

            this.checkin = Object.assign(this.checkin, params)
            this.checkin.member_id = params.id;
            axios.post('/backoffice/members/checkin', this.checkin)
                .then(response => {

                    this.checkInProgress = false;
                    if (response.data.status==="OK") {

                        this.checkInModel = response.data;
                        this.checkInSuccess = true;

                        this.checkInModal = false
                        this.checkin.card_id = null
                        this.checkin.id = null
                        this.checkin.membership_id = null
                     }else if(response.data.status === "CHECKOUT"){

                        EventBus.$emit('SUCCESS_CHECKOUT', response.data);
                        this.checkInModal = false;
                        this.checkInModel.card_id = null;
                        this.checkInModel.id = null;
                        this.checkInModel.membership_id = null;
                        this.$inertia.reload()

                    }else if (response.data.status==="CONFIRM") {
                        this.memberSubs = response.data.subscriptions
                        this.checkInModal = true
                    } else {
                        this.messageObjects.push({
                                message: response.data.message,
                                color: 'error',
                                timeout: 10000
                            })
                    }
                    this.sub = null
                })
                .catch(error => {
                    this.checkInProgress = false;
                    this.sub = null
                })
        }
    },
    mounted() {
        if(sessionStorage.isMini) {
            this.toggleMini = JSON.parse(sessionStorage.isMini)
        }

        let cardId = ""
        let prevTimestap = null
        let self = this
        window.addEventListener("keydown", e => {
            if (e.key === "Enter" && cardId.length > 5){
              self.checkIn({card_id: cardId});
              cardId = ""
              prevTimestap = null
            } else {
                if ((prevTimestap == null || e.timeStamp - prevTimestap < 30) && e.target.tagName != "INPUT") {
                    cardId += e.key
                    prevTimestap = e.timeStamp
                } else {
                    cardId = ""
                    prevTimestap = null
                }
            }
        })
    },
    beforeDestroy() {
        if (this.toggleMini===true) {
            sessionStorage.setItem('isMini', true)
        } else {
            sessionStorage.setItem('isMini', false)
        }
    },
}
</script>
